/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:15:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-07 11:57:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/ContentCategory/Card/index.tsx
 */
import React from 'react';

import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { GeneralCard1 } from 'src/pages/SalesChannelCategory/Components/Card';

const Card = (props) => {
  const {
    //name, slug, isRoot, parent, url, contentVersion,
    canEdit,
    onEdit,
    ...rest
  } = props;

  return (
    <React.Fragment>
      <SectionContent hasBottomBorder>
        <GeneralCard1
          // parent={parent}
          // url={url}
          // isRoot={isRoot}
          // name={name}
          // slug={slug}
          // contentVersion={contentVersion}
          canEdit={canEdit}
          onEdit={onEdit}
          {...rest}
        />
      </SectionContent>
    </React.Fragment>
  );
};
export default Card;
// HOC(Card, {
//   getCollapse,
//   getContent: getRoot,
//   title: 'Root',
//   onCollapseChange,
//   getLoaded,
// });
